<template>
	<div class="message-reasoning">
		<button-reasoning
			@click="openReasoningMessage"
			class="message-reasoning-btn"
			:show-chevron="true"
			:active="showMessage"
		/>
		<Transition>
			<div v-if="showMessage" class="message-reasoning-text">
				{{ props.message }}
			</div>
		</Transition>
	</div>
</template>

<script setup lang="ts">
import ButtonReasoning from '@/components/ui/ButtonReasoning.vue'
import { ref } from 'vue'

const props = defineProps({
	message: { type: String, required: true },
	showMessageDefault: { type: Boolean, default: false }
})

const showMessage = ref(props.showMessageDefault)

function openReasoningMessage() {
	showMessage.value = !showMessage.value
}
</script>

<style lang="scss" scoped>
.message-reasoning {
	margin-top: 20px;
	margin-bottom: 12px;
	width: 100%;
	&-btn {
		margin-bottom: 8px;
	}
	&-text {
		border-left: 2px solid var(--border-brand);
		padding-left: 10px;
		font: var(--font-body-small);
		color: var(--text-secondary);
	}
}
</style>
